<template>
  <div class="c-header-search-input-mobile">
    <div class="c-header-search-input-mobile__wrapper">
      <i class="c-header-search-input-mobile__icon icon-search"></i>
      <input
        class="c-header-search-input-mobile__input"
        :placeholder="placeholder"
        @focus="handleSearchFocus"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: 'ComponentsHeaderSearchInputMobile',
  props: {
    placeholder: { type: String, default: '' },
  },
  methods: {
    handleSearchFocus() {
      this.$emit('search-focus')
    },
  },
}
</script>

<style lang="scss" scoped>
@use '~/scss/generic/variables';

.c-header-search-input-mobile {
  &__input {
    padding: 8px 0px;
    width: 100%;
  }

  &__wrapper {
    padding: 5px 24px;
    border: 1px solid variables.$color-brown;
    border-radius: 6px;
    background-color: #fff;
    display: flex;
    align-items: center;
  }

  &__icon {
    font-size: 18px;
    margin-right: 8px;
  }

  &__input {
    border: 0;
    background-color: transparent;
    flex-grow: 1;
    font-size: 14px;
    outline: none;
  }

  &__h1 {
    color: variables.$color-brown;
    font-weight: 300;
    font-size: 10px;
    margin-top: 4px;
    width: 100%;
  }
}

input::placeholder {
  appearance: none;
  color: #ccc !important;
  opacity: 1;
}
</style>
